import slackIcon from '../images/slack-icon.svg'
export default {
    connectors: {
        'slack-connector': {
            id: 'slack-connector',
            iconSrc: slackIcon,
            title: 'Slack',
            description: 'Get alerts for new emails, assignments and note mentions in Slack',
            checkboxOptions: [{
                id: 'new_sm_email',
                title: 'Send new conversation alerts to Slack',
                withSelect: true,
                selectLabel: 'Select slack channel'
            }, {
                id: 'email_assigned',
                title: 'Send Assignments to Slack',
            },{
                id: 'new_mention',
                title: 'Send @mentions in notes to Slack'
            }],
            selectOptions: [],
            selectedValue: null
        }
    },
    sharedMailboxes: {},
    isLoading: false
}